import React, {
    Fragment,
} from 'react';

import Footer from 'wanderu-component-footer';
import {
    Section,
    ValueProps,
    PageTitle,
    PageSection,
    StatisticsBanner,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import {
    HERO_HEADER,
    PRESS_CAROUSEL_DATA,
    PRESS_PAGE_URL,
    PRESS_QUOTE_IMAGE,
    REVIEW_CAROUSEL_DATA,
    STAR_URL,
} from '../../constants';
import AboutUsCarouselSection from '../AboutUsCarouselSection/AboutUsCarouselSection';
import AboutUsMeta from '../AboutUsMeta/AboutUsMeta';
import AwardsSection from '../AwardsSection/AwardsSection';
import CareerBlogSection from '../CareerBlogSection/CareerBlogSection';
import ChikuSection from '../ChikuSection/ChikuSection';
import FoundersSection from '../FoundersSection/FoundersSection';
import IntroSection from '../IntroSection/IntroSection';
import PartnersSection from '../PartnersSection/PartnersSection';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './AboutUs.scss';

function AboutUsHeader({ title }) {
    return (
        <PageSection
            aria-labelledby="header-title"
            className={styles.headerSection}
            layoutClassName={styles.headerSectionLayout}
        >
            <PageTitle
                className={styles.title}
                id="header-title"
            >
                {title}
            </PageTitle>
            <img
                alt=""
                className={styles.headerImage}
                src={HERO_HEADER}
            />
        </PageSection>
    );
}

function PressQuotes({ t, content, source }) {
    return (
        <div className={styles.pressCarouselItem}>
            <blockquote className={styles.content}>
                {t(content)}
            </blockquote>
            <div className={styles.source}>
                {t(source)}
            </div>
        </div>
    );
}

function ReviewCard({
    t, source, name, label, content,
}) {
    return (
        <div className={styles.reviewCard}>
            <span className={styles.reviewerName}>
                {t(name)}
            </span>
            <img
                alt=""
                className={styles.reviewStars}
                src={STAR_URL}
            />
            <img
                alt=""
                className={styles.reviewSource}
                src={source}
            />
            <span className={styles.reviewLabel}>
                {t(label)}
            </span>
            <span className={styles.reviewContent}>
                {t(content)}
            </span>
        </div>
    );
}

function AboutUs(props) {
    const {
        staticContext,
        t,
    } = props;

    const pressCarouselData = PRESS_CAROUSEL_DATA.map(
        (carouselData) => (
            <PressQuotes
                {...carouselData}
                key={t(carouselData.content)}
                t={t}
            />
        ),
    );
    const reviewsCarouselData = REVIEW_CAROUSEL_DATA.map(
        (carouselData) => (
            <ReviewCard
                {...carouselData}
                key={t(carouselData.label)}
                t={t}
            />
        ),
    );

    if (staticContext) {
        staticContext.cache = {
            secondsFromNow: 60 * 60 * 24 * 7,
        };
    }

    return (
        <Fragment>
            <div className={styles.container}>
                <AboutUsMeta />
                <AboutUsHeader
                    title={t('about-us-header-title')}
                />
                <IntroSection />
                <Section>
                    <ValueProps variant="spacious"/>
                </Section>
                <StatisticsBanner
                    label="numbers-section"
                    layoutClassName={styles.imageBannerLayout}
                    subtitle={t('about-us-numbers-description')}
                    title={t('about-us-numbers-title')}
                />
                <PartnersSection
                    buttonLabel={t('about-us-partners-button-label')}
                    description={t('about-us-partners-description')}
                    title={t('about-us-partners-title')}
                />
                <AwardsSection
                    description={t('about-us-awards-description')}
                    title={t('about-us-awards-title')}
                />
                <AboutUsCarouselSection
                    buttonLabel={t('about-us-press-button-label')}
                    buttonUrl={PRESS_PAGE_URL}
                    carouselData={pressCarouselData}
                    description={t('about-us-press-description')}
                    label="press-section"
                    layoutClassName={styles.pressSectionLayout}
                    subheaderImage={PRESS_QUOTE_IMAGE}
                    title={t('about-us-press-title')}
                />
                <AboutUsCarouselSection
                    carouselClassName={styles.reviewsCarousel}
                    carouselData={reviewsCarouselData}
                    className={styles.reviewsSection}
                    description={t('about-us-reviews-description')}
                    descriptionClassName={styles.reviewsSectionDescription}
                    label="reviews-section"
                    layoutClassName={styles.reviewsSectionLayout}
                    title={t('about-us-reviews-title')}
                    showHints
                />
                <ChikuSection
                    buttonLabel={t('about-us-chiku-button-label')}
                    description={t('about-us-chiku-description')}
                    title={t('about-us-chiku-title')}
                />
                <FoundersSection />
                <CareerBlogSection />
            </div>
            <Footer />
        </Fragment>
    );
}

export {
    AboutUs,
    AboutUsHeader,
    PressQuotes,
    ReviewCard,
};
export default localize(AboutUs, ['t'], 'baseApp');
